import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
})
export class FormFieldComponent {
  @Input() label = '';
  @Input() required = false;
  @Input() optional = false;
  @Input() control: AbstractControl | null = null;
  @Input() submitted = false;
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() serverError: string | null | undefined = '';
  /** Verb used in the default "required" message, e.g. "Please Enter <label>" / "Please Select <label>". */
  @Input() actionVerb = 'Enter';

  get showErrors(): boolean {
    return !!(this.submitted && this.control && this.control.invalid);
  }

  get errorKeys(): string[] {
    if (!this.showErrors || !this.control?.errors) {
      return [];
    }
    return Object.keys(this.control.errors);
  }

  messageFor(key: string): string {
    if (this.errorMessages[key]) {
      return this.errorMessages[key];
    }
    const errorValue = this.control?.errors?.[key];
    switch (key) {
      case 'required':
        return `Please ${this.actionVerb} ${this.label}`;
      case 'pattern':
      case 'email':
        return `Please Enter Valid ${this.label}`;
      case 'minlength':
        return `Please Enter Minimum Length ${errorValue?.requiredLength ?? ''}`;
      case 'twoSpaces':
        return 'More than two consecutive spaces are not allowed';
      default:
        return `Invalid ${this.label}`;
    }
  }
}
